import React, {Component} from "react";
import {Table, Icon} from 'antd';
import PropTypes from 'prop-types';
import NHInputRender from "../../common/NHInputPicker/render";

/**
 * 环节管理查看表单
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-16 11:40:18
 * Version: 1.0
 * Modify log:
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {

        const columns = [
            {
                title: '排序',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px',
            }, {
                title: '字段名称',
                key: 'zdmc',
                dataIndex: 'zdmc',
                width: '110px'
            }, {
                title: '输入框类型',
                key: 'kjcs',
                dataIndex: 'kjcs',
                width: '110px',
                render: (text, record) => {
                    return <NHInputRender feature={record.kjcs}/>
                }
            }, {
                title: '默认值',
                key: 'mrz',
                dataIndex: 'mrz',
                width: '80px'
            }, {
                title: '是否必填',
                key: 'sfbt',
                dataIndex: 'sfbt',
                width: '60px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }, {
                title: '是否启用',
                key: 'zt',
                dataIndex: 'zt',
                width: '60px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }
        ];

        const {hjdyVO, hjywxVOs} = this.props.initFormData;

        for (let key in hjywxVOs) {

            let ywxdyVO = hjywxVOs[key].ywxdyVO;
            if (ywxdyVO != null) {
                let zdmc = ywxdyVO.zdmc;
                let kjcs = ywxdyVO.kjcs;
                hjywxVOs[key].zdmc = zdmc;
                hjywxVOs[key].kjcs = kjcs;
            }
        }

        return (
            <div>
                <Table dataSource={hjywxVOs} columns={columns} pagination={false}/>
            </div>
        )
    }
}

ViewForm.propTypes = {
    initFormData: PropTypes.object, //初始表单数据
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/lcgl/hjgl/ViewForm.js